// extracted by mini-css-extract-plugin
module.exports = {"cp-price-list__row":"styles_cp-price-list__row__27PbT","cp-price-list__row--disabled":"styles_cp-price-list__row--disabled__2h4jR"};